angular
	.module 'App.Module.PredefinedLineitemDiscount', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'predefined_lineitem_discounts',
				url: '/predefined_lineitem_discounts',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'
					'entity_search@predefined_lineitem_discounts':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.Setting.Predefined.LineItem.Discounts.Enabled'
					searchParams:
						repositoryName: 'PredefinedLineitemDiscountRepository'
						title: 'general.predefined_line_item.discounts'

			.state 'predefined_lineitem_discounts.edit',
				url: '/:id'
				abstract: true
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					predefinedLineitemDiscount: (PredefinedLineitemDiscountRepository, $stateParams) ->
						return PredefinedLineitemDiscountRepository.getEntity $stateParams.id

			.state 'predefined_lineitem_discounts.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'PredefinedLineitemDiscountController'
						controllerAs: 'vm'
						templateUrl: '@app/predefined-lineitem-discount/predefined-lineitem-discount.view.html'

